import React, { useEffect, useState } from "react";

const copy = {
  nl: {
    text: "We gebruiken cookies voor analytics.",
    accept: "Akkoord",
    reject: "Weigeren",
  },
  en: {
    text: "We use cookies for analytics.",
    accept: "Accept",
    reject: "Reject",
  },
};

export default function CookieConsentBar({ onClose, lang = "nl" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("cookie-consent");
    if (!saved) setVisible(true);
  }, []);

  if (!visible) return null;

  const t = copy[lang] || copy.nl;

  const accept = () => {
    localStorage.setItem("cookie-consent", "accepted");

    // Enable consent
    window.gtag?.("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "granted",
    });



    setVisible(false);
    onClose?.("accepted");
  };

  const reject = () => {
    localStorage.setItem("cookie-consent", "rejected");

    window.gtag?.("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied",
    });

    setVisible(false);
    onClose?.("rejected");
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#2b373b",
        color: "#fff",
        padding: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
      }}
    >
      <p style={{ margin: 0 }}>{t.text}</p>

      <div style={{ display: "flex", gap: "8px" }}>
        <button onClick={reject}>{t.reject}</button>
        <button onClick={accept}>{t.accept}</button>
      </div>
    </div>
  );
}